import _ from 'lodash'
import React from 'react'

import { NEUTRAL_COLOURS } from 'constants/colors'
import { Child } from 'services/child/constants'

import { generateRoute } from 'utils/routing'

import { DefinitionList, Section, Space, TimeString, Typography } from 'components'

import i18n from 'translations'

import {
  StyledDayContainer,
  StyledItemContainer,
  StyledPlanContainer,
  StyledPlanGroupContainer,
  StyledPlanItemContainer,
  StyledSessionContainer,
  StyledSessionContentContainer,
} from './ChildSessionsListStyled'

interface ChildSessionsListProps {
  attendancePeriodText: string
  child?: Child
  childSession: any
  displayAddAction?: boolean
  isPreview?: boolean
  sectionVariant?: any
  title?: string
}

const ChildSessionsList = ({
  attendancePeriodText,
  child,
  childSession,
  displayAddAction,
  isPreview,
  sectionVariant,
  title,
}: ChildSessionsListProps) => {
  const { formattedPlans, id } = childSession
  const { id: childId } = child || {}

  const renderPlan = ({ archived, endTime, sessionName, startTime }, i) => (
    <StyledPlanContainer key={_.kebabCase(i)}>
      <StyledPlanGroupContainer>
        <StyledPlanItemContainer $highlighted>
          {!isPreview && (
            <React.Fragment>
              <TimeString date={startTime} local={false} />
              <span>
            &nbsp;-&nbsp;
              </span>
              <TimeString date={endTime} local={false} />
            </React.Fragment>
          )}
          {isPreview && i18n.t('module:Children:Child:BookingPattern:Sessions:Add:sessionTime')}
        </StyledPlanItemContainer>
      </StyledPlanGroupContainer>
      <StyledPlanGroupContainer>
        <StyledPlanItemContainer>
          {`${sessionName}${archived ? ` (${i18n.t('global:archived')})` : ''}`}
        </StyledPlanItemContainer>
      </StyledPlanGroupContainer>
    </StyledPlanContainer>
  )

  const renderSessions = (plans) => {
    if (!plans.length) {
      return (
        <Typography color={NEUTRAL_COLOURS.GRAY}>
          {i18n.t('module:Children:Child:BookingPattern:Sessions:Add:noSessions')}
        </Typography>
      )
    }

    return _.map(plans, renderPlan)
  }

  const renderDay = ({ dayOfWeek, plans }, i) => (
    <StyledItemContainer key={_.kebabCase(i)}>
      <StyledDayContainer>
        {dayOfWeek.toUpperCase().substring(0, 3)}
      </StyledDayContainer>
      <StyledSessionContentContainer>
        {renderSessions(plans)}
      </StyledSessionContentContainer>
    </StyledItemContainer>
  )

  const renderBody = () => (
    <React.Fragment>
      <DefinitionList>
        <DefinitionList.Item
          label={i18n.t('module:Children:Child:BookingPattern:Sessions:Add:attendancePeriod')}
          value={attendancePeriodText}
          horizontal
        />
      </DefinitionList>
      <Space space="20px" />
      <StyledSessionContainer>
        {_.map(formattedPlans, renderDay)}
      </StyledSessionContainer>
    </React.Fragment>
  )

  if (!title) {
    return (
      <React.Fragment>
        {renderBody()}
        <Space space="50px" />
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <Section
        actions={displayAddAction && (
          <Section.Actions
            tertiary={{ to: generateRoute('CHILDREN.CHILD.BOOKING_PATTERN.SESSIONS.EDIT', { childId, sessionId: id }) }}
          />
        )}
        title={title}
        variant={sectionVariant}
      >
        {renderBody()}
      </Section>
      <Space space="50px" />
    </React.Fragment>
  )
}

export default ChildSessionsList
